export function syncRouteStateFromStorage({ Tool, store }) {
  const moduleId = Tool.getStorage("module_id");
  if (moduleId) {
    store.dispatch("setModuleId", moduleId);
    const innerSlider = Tool.getStorage("innerSlider");
    if (innerSlider) {
      Tool.setStorage("innerSlider", innerSlider);
      store.dispatch("setInnerSlider", innerSlider);
    }
  }

  const sliderActiveIndex = Tool.getStorage("sliderActiveIndex");
  if (sliderActiveIndex) {
    store.dispatch("setActiveIndex", sliderActiveIndex);
  }

  const openMenu = Tool.getStorage("openMenu");
  if (openMenu && openMenu[0] !== store.state.openMenu[0]) {
    store.dispatch("setOpenMenu", openMenu);
  }

  const companyIsmajor = Tool.getStorage("company_ismajor");
  if (companyIsmajor) {
    store.dispatch("set_companyIsmajor", companyIsmajor);
  }
}

export function bootstrapStoreFromStorage({ Tool, store, router }) {
  const stafferId = Tool.getStorage("staffer_id");
  const originalToken = Tool.getStorage("original_token");
  const companyId = Tool.getStorage("company_id");
  const schoolId = Tool.getStorage("school_id");

  if (
    stafferId == "undefined" ||
    originalToken == "undefined" ||
    companyId == "undefined" ||
    schoolId == "undefined"
  ) {
    router.push({
      path: "/havePermission",
      // querry: { redirect: router.currentRoute.fullPath } //从哪个页面跳转
    });
  }

  if (stafferId != null) {
    if (Tool.getStorage("school_id")) {
      const token = Tool.getStorage("token");
      const marketerId = Tool.getStorage("marketer_id");
      const userInfo = Tool.getStorage("userInfo");
      store.dispatch("setSchoolId", schoolId); //存储schoolid
      store.dispatch("setCompanyId", companyId); //存储companyId
      store.dispatch("setUserToken", token); //用户token
      store.dispatch("setMarketerId", marketerId);
      store.dispatch("setUserInfo", userInfo); //更新用户信息

      store.dispatch("setPostbeCrmlevel", Tool.getStorage("PostbeCrmlevel")); //更新权限信息
      // 侧边栏菜单
      store.dispatch("setSlider", Tool.getStorage("Slider"));
    }

    const navActiveIndex = Tool.getStorage("navActiveIndex");
    if (navActiveIndex) {
      store.dispatch("setNavActiveIndex", navActiveIndex);
    } else {
      Tool.setStorage("navActiveIndex", "2");
      store.dispatch("setNavActiveIndex", "2");
    }
  }
}

